function getPos(_e: any) {
  const e = ((_e.touches && _e.touches[0]) || _e) as MouseEvent
  return { x: e.clientX, y: e.clientY }
}

type HandleCallbackProps = {
  pos: { x: number, y: number },
  deltaPos: { x: number, y: number },
  startPos: { x: number, y: number },
  e: MouseEvent
}

type HandleEventOpts = {
  onStart?: (props: HandleCallbackProps) => void
  onMove?: (props: HandleCallbackProps) => void,
  onEnd?: (props: HandleCallbackProps) => void
}

export function getMove(e: any, { onStart, onMove, onEnd }: HandleEventOpts = {}) {

  const startPos = getPos(e)
  let lastPos = startPos

  const move = (e: any) => {
    const pos = getPos(e)
    if (onMove)
      onMove({ pos, deltaPos: { x: pos.x - lastPos.x, y: pos.y - lastPos.y}, startPos, e })
    lastPos = pos
  }

  const end = (e: any) => {
    const pos = getPos(e)
    document.removeEventListener("touchmove", move)
    document.removeEventListener("mousemove", move)
    if (onEnd)
      onEnd({ pos, deltaPos: { x: pos.x - lastPos.x, y: pos.y - lastPos.y}, startPos, e })
  }

  if (onStart)
    onStart({ pos: startPos, deltaPos: { x: 0, y: 0 }, startPos, e })

  if (e.touches) {
    document.addEventListener("touchmove", move)
    document.addEventListener("touchend", end, { once: true })
  } else {
    document.addEventListener("mousemove", move)
    document.addEventListener("mouseup", end, { once: true })
  }
}


type HandleRotateCallbackProps = {
  angle: number
  deltaAngle: number
}

type HandleRotateEventOpts = {
  onStart?: (props: HandleRotateCallbackProps) => void
  onMove?: (props: HandleRotateCallbackProps) => void,
  onEnd?: (props: HandleRotateCallbackProps) => void
}

export function getAngleMove(e: any, center: { x: number, y: number }, { onStart, onMove, onEnd }: HandleRotateEventOpts = {}) {

  const startPos = getPos(e)
  let startAngle = Math.atan2(startPos.y - center.y, startPos.x - center.x) 

  let lastAngle = 0
  const move = (e: any) => {
    const pos = getPos(e)
    const angle = (Math.atan2(pos.y - center.y, pos.x - center.x) - startAngle) / Math.PI * 180
    if (onMove)
      onMove({ angle, deltaAngle: angle-lastAngle })
    lastAngle = angle
  }

  const end = (e: any) => {
    const pos = getPos(e)
    const angle = (Math.atan2(pos.y - center.y, pos.x - center.x) - startAngle) / Math.PI * 180
    document.removeEventListener("touchmove", move)
    document.removeEventListener("mousemove", move)
    if (onEnd)
      onEnd({ angle, deltaAngle: angle-lastAngle })
  }

  move(e)
  if (onStart)
    onStart({ angle: 0, deltaAngle: 0 })

  if (e.touches) {
    document.addEventListener("touchmove", move)
    document.addEventListener("touchend", end, { once: true })
  } else {
    document.addEventListener("mousemove", move)
    document.addEventListener("mouseup", end, { once: true })
  }
}


type HandleScaleCallbackProps = {
  scale: number
  deltaScale: number
}

type HandleScaleEventOpts = {
  onStart?: (props: HandleScaleCallbackProps) => void
  onMove?: (props: HandleScaleCallbackProps) => void,
  onEnd?: (props: HandleScaleCallbackProps) => void
}

export function getScaleMove(e: any, center: { x: number, y: number }, { onStart, onMove, onEnd }: HandleScaleEventOpts = {}) {

  const startPos = getPos(e)
  let startScale = Math.hypot(startPos.y - center.y, startPos.x - center.x)

  let lastScale = 1
  const move = (e: any) => {
    const pos = getPos(e)
    const scale = Math.hypot(pos.y - center.y, pos.x - center.x) / startScale
    if (onMove)
      onMove({ scale, deltaScale: scale/lastScale })
    lastScale = scale
  }

  const end = (e: any) => {
    const pos = getPos(e)
    const scale = Math.hypot(pos.y - center.y, pos.x - center.x) / startScale
    document.removeEventListener("touchmove", move)
    document.removeEventListener("mousemove", move)
    if (onEnd)
      onEnd({ scale, deltaScale: scale/lastScale })
  }

  move(e)
  if (onStart)
    onStart({ scale: 1, deltaScale: 1 })

  if (e.touches) {
    document.addEventListener("touchmove", move)
    document.addEventListener("touchend", end, { once: true })
  } else {
    document.addEventListener("mousemove", move)
    document.addEventListener("mouseup", end, { once: true })
  }
}